import { render, staticRenderFns } from "./MarketingPage.vue?vue&type=template&id=12c89126&scoped=true&"
import script from "./MarketingPage.vue?vue&type=script&lang=js&"
export * from "./MarketingPage.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPage.vue?vue&type=style&index=0&id=12c89126&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c89126",
  null
  
)

export default component.exports